import React from "react";
import Img from "react-image";
import _ from "lodash";
import { connect } from "react-redux";
import srcIconCheck from "../../../../../../styles/img/icon-check-white.svg";
import moment from "moment";
import {
  postActiviteSimple,
  postActiviteMulti,
  updateActiviteEvent,
  DeleteActiviteEvent,
} from "../les-tabs-ducks/Activite.ducks";
import Classnames from "classnames";
import { withTranslation } from 'react-i18next';
import { TimePickerCustom } from "../../../../../../../src/components"

const IconCheckWhite = () => <Img src={srcIconCheck} className="img-fluid" />;

moment.locale("fr");

function notEmpty(value) {
  return !_.isEmpty(value);
}

class Activite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      typeActivite: "",
      readySubmit: false,
      show: false,
      libelle: "",
      id: "",
      opacity: { opacity: 0.25, pointerEvents: "none" },
      initialized: false,
      isOpen: true,
      timeActivite: moment(),
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.myChangeHandler = this.myChangeHandler.bind(this);
    this.handleEventDelete = this.handleEventDelete.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      !this.state.initialized &&
      (this.props.isUpdate || this.props.onlyView) &&
      !_.isEmpty(this.props.activiteData)
    ) {
      let activiteData = this.props.activiteData;
      let kidItem = this.props.kidItem;
      if (activiteData.activiteType === "AUTRE") {
        this.setState({
          typeActivite: "AUTRE",
          timeActivite: moment(activiteData.dateTime),
          show: true,
          libelle: activiteData.libelle,
          initialized: true,
        });
      } else {
        this.setState({
          typeActivite: activiteData.activiteType,
          timeActivite: moment(activiteData.dateTime),
          show: false,
          libelle: activiteData.libelle,
          initialized: true,
        });
      }
    }
  }
  toggle() {
    this.props.toggle();
    this.setState({ readySubmit: false, typeActivite: "" });
  }
  myChangeHandler = (event) => {
    this.setState({ libelle: event.target.value, opacity: { opacity: 1 } });
  };

  handleChange = (event) => {
    if (!this.props.onlyView) {
      let name = event.target.name;
      this.setState(
        {
          [name]: event.target.id,
          opacity: { opacity: 0.25, pointerEvents: "none" },
        },
        () => {
          let readySubmit = this.props.readySubmit;
          let tabSubmit;
          notEmpty(this.state.typeActivite)
            ? (tabSubmit = true)
            : (tabSubmit = false);
          if (tabSubmit && readySubmit === false) {
            this.props.handleReadySubmit();
          } else if (tabSubmit === false && readySubmit) {
            this.props.handleReadySubmit();
          }
        }
      );
      if (!(event.target.id === "AUTRE")) {
        this.setState({ opacity: { opacity: 1 } });
      }
      if (event.target.id === "AUTRE") {
        this.setState({ show: true });
      } else {
        this.setState({
          show: false,
        });
      }
    }
  };

  handleChangeDate = (date) => {
    if (!this.props.onlyView) {
      this.setState({ timeActivite: date }, () => {
        if (
          notEmpty(this.state.timeActivite)
        ) {
          this.setState({ opacity: { opacity: 1 } });
        } else {
          this.setState({ opacity: { opacity: 0.25, pointerEvents: "none" } });
        }
      });
    }
  };

  handleSubmit(event) {
    event.preventDefault();

    if (
      this.props.isUpdate &&
      notEmpty(this.props.kidItem) &&
      notEmpty(this.state.typeActivite) &&
      !this.props.onlyView
    ) {
      let data = {
        activiteType: this.state.typeActivite,
        dateTime: moment(this.state.timeActivite).format(),
        libelle: this.state.libelle,
      };
      this.props.updateActiviteEvent(
        localStorage.getItem("token"),
        this.props.idEvent,
        data
      );
    } else if (
      this.props.submitMulti &&
      notEmpty(this.state.typeActivite) &&
      !this.props.onlyView
    ) {
      let listIds = this.props.dataMulti.listChild;
      let data = {
        activite: {
          activiteType: this.state.typeActivite,
          dateTime: moment(this.state.timeActivite).format(),
          libelle: this.state.libelle,
        },
        idsEnfants: listIds,
      };

      this.props.postActiviteMulti(localStorage.getItem("token"), data);
    } else if (
      notEmpty(this.props.kidItem) &&
      notEmpty(this.state.typeActivite) &&
      !this.props.onlyView
    ) {
      let data = {
        activiteType: this.state.typeActivite,
        dateTime: moment(this.state.timeActivite).format(),
        libelle: this.state.libelle,
      };
      this.props.postActiviteSimple(
        localStorage.getItem("token"),
        this.props.kidItem.id,
        data
      );
    }

    this.props.handleSubmit();
  }
  handleEventDelete(e) {
    e.preventDefault();
    this.props.DeleteActiviteEvent(
      localStorage.getItem("token"),
      this.props.idEvent
    );
  }

  render() {
    const { t } = this.props;
    return (
      <div
        className="tab-pane  show active"
        id="activite-pane"
        role="tabpanel"
        aria-labelledby="activite-tab"
      >
        <div className="content">
        <h2 className="mb-2">{t('modal_enfant.activite_tab.at_what_time')}</h2>
            <TimePickerCustom 
              isOpen={this.state.isOpen} 
              time={this.state.timeActivite} 
              handleChangeDate={this.handleChangeDate} 
              onlyView={this.props.onlyView}/>

        <h2 style={{ marginTop: "15px" }}>{t('modal_enfant.activite_tab.select_activity')}</h2>
          <div className="row mx-n2 mb-4 d-flex align-items-center objet-sante">
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="PATE_A_MODELER"
                value={this.state.typeActivite}
                name="typeActivite"
              />
              <label
                htmlFor="PATE_A_MODELER"
                className={Classnames("pate-a-modeler", {
                  active: this.state.typeActivite === "PATE_A_MODELER",
                })}
              >
                <span>{t('modal_enfant.activite_tab.pate_a_modeler')}</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="PEINTURE"
                value={this.state.typeActivite}
                name="typeActivite"
              />
              <label
                htmlFor="PEINTURE"
                className={Classnames("peinture", {
                  active: this.state.typeActivite === "PEINTURE",
                })}
              >
                <span>{t('modal_enfant.activite_tab.peinture')}</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="DANSE"
                value={this.state.typeActivite}
                name="typeActivite"
              />
              <label
                htmlFor="DANSE"
                className={Classnames("danse", {
                  active: this.state.typeActivite === "DANSE",
                })}
              >
                <span>{t('modal_enfant.activite_tab.danse')}</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="SORTIE"
                value={this.state.typeActivite}
                name="typeActivite"
              />
              <label
                htmlFor="SORTIE"
                className={Classnames("sortie", {
                  active: this.state.typeActivite === "SORTIE",
                })}
              >
                <span>{t('modal_enfant.activite_tab.sortie')}</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="PISCINE"
                value={this.state.typeActivite}
                name="typeActivite"
              />
              <label
                htmlFor="PISCINE"
                className={Classnames("piscine", {
                  active: this.state.typeActivite === "PISCINE",
                })}
              >
                <span>{t('modal_enfant.activite_tab.piscine')}</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="LECTURE"
                value={this.state.typeActivite}
                name="typeActivite"
              />
              <label
                htmlFor="LECTURE"
                className={Classnames("lecture", {
                  active: this.state.typeActivite === "LECTURE",
                })}
              >
                <span>{t('modal_enfant.activite_tab.lecture')}</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="ACTIVITE_MANUELLE"
                value={this.state.typeActivite}
                name="typeActivite"
              />
              <label
                htmlFor="ACTIVITE_MANUELLE"
                className={Classnames("activites-manuelles", {
                  active: this.state.typeActivite === "ACTIVITE_MANUELLE",
                })}
              >
                <span>{t('modal_enfant.activite_tab.activites_manuelles')}</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none autre-mess-ipt"
                id="AUTRE"
                value={this.state.typeActivite}
                name="typeActivite"
              />
              <label
                htmlFor="AUTRE"
                className={Classnames("autre-mess", {
                  active: this.state.typeActivite === "AUTRE",
                })}
              >
                <span>{t('modal_enfant.activite_tab.autre')}</span>
              </label>
            </div>
          </div>
          {this.state.show ? (
            <div className="autre-etat-sante mt-3">
              <div className="row">
                <div className="col-md-6 offset-md-3">
                  <textarea
                    className="box-shadow"
                    value={this.state.libelle}
                    onChange={this.myChangeHandler}
                  ></textarea>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="d-flex justify-content-center">
          {this.props.onlyView ? (
            ""
          ) : (
            <button
              type="submit"
              className="btn-gradient btn-valid"
              onClick={this.handleSubmit}
              style={this.state.opacity}
            >
              <IconCheckWhite /> {t('common.validate')}
            </button>
          )}
          {this.props.isUpdate ? (
            <button onClick={this.handleEventDelete} className="btn-supprimer">
              {t('common.delete')}
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  postActiviteSimple,
  postActiviteMulti,
  updateActiviteEvent,
  DeleteActiviteEvent,
};
const mapStateToProps = ({ modals }) => ({ modals });
const withStore = connect(mapStateToProps, mapDispatchToProps);
export default withStore(withTranslation()(Activite));
